<script setup>
import { computed, defineProps } from 'vue';
import { useStore } from 'vuex'
import moment from 'moment';

const props = defineProps({
   ovr: {
    type: Object,
    required: true
   } 
});

const store = useStore();

const loading = computed(() => store.state.globals.loading);
</script>

<template>
<b-overlay :show="loading">
    <div class="row m-3">
        <table class="table table-bordered table-sm table-light m-0">
            <tbody>
                <tr>
                    <th colspan="2" class="text-center">OVR</th>
                </tr>
                <tr>
                    <td class="no-wrap">OVR No.</td>
                    <td>{{ props.ovr.ovr_number ? props.ovr.ovr_number : 'n/a' }}</td>
                </tr>
                <tr>
                    <td class="no-wrap">Date Created</td>
                    <td>{{ props.ovr.date_created ? moment(props.ovr.date_created).format('YYYY-MM-DD hh:mm A') : 'n/a' }}</td>
                </tr>
                <tr>
                    <td class="no-wrap">Apprehending Officer</td>
                    <td>{{ props.ovr.apprehending_officer ? props.ovr.apprehending_officer : 'n/a'}}</td>
                </tr>
                <tr>
                    <td class="no-wrap">Print (Dot Matrix)</td>
                    <td>n/a</td>
                </tr>
            </tbody>
        </table>
    </div>
</b-overlay>
</template>

<style scoped>
.no-wrap{
  min-width: fit-content;
  width: 100px;
  white-space: nowrap;
}
th, td {
    background-color: #fff;
}
td{
  padding: 5px;
  text-align: center;
}
</style>
